export const GATEWAY_CLEARANCE_KEY = 'luacentrix.gateway.clearance';

export const GATEWAY_CLEARANCE_VERSION = 1;

export const GATEWAY_CLEARANCE_TTL_MS = 12 * 60 * 60 * 1000;

export interface GatewayClearance {
  version: number;
  cleared_at_ms: number;
  expires_at_ms: number;
}

let memoryClearance: GatewayClearance | null = null;

function isSafeMillis(value: unknown): value is number {
  return typeof value === 'number' && Number.isSafeInteger(value) && value > 0;
}

function parseClearance(raw: string | null, now: number): GatewayClearance | null {
  if (raw === null) {
    return null;
  }
  let payload: unknown;
  try {
    payload = JSON.parse(raw) as unknown;
  } catch {
    return null;
  }
  if (typeof payload !== 'object' || payload === null || Array.isArray(payload)) {
    return null;
  }
  const record = payload as Record<string, unknown>;
  const version = record['version'];
  const cleared = record['cleared_at_ms'];
  const expires = record['expires_at_ms'];
  if (version !== GATEWAY_CLEARANCE_VERSION) {
    return null;
  }
  if (!isSafeMillis(cleared) || !isSafeMillis(expires)) {
    return null;
  }
  if (expires <= now || cleared > now + 60_000) {
    return null;
  }
  return { version: GATEWAY_CLEARANCE_VERSION, cleared_at_ms: cleared, expires_at_ms: expires };
}

export function readClearance(now = Date.now()): GatewayClearance | null {
  if (memoryClearance !== null) {
    if (memoryClearance.expires_at_ms > now) {
      return memoryClearance;
    }
    memoryClearance = null;
  }
  try {
    return parseClearance(window.localStorage.getItem(GATEWAY_CLEARANCE_KEY), now);
  } catch {
    return null;
  }
}

export function writeClearance(now = Date.now()): GatewayClearance {
  const value: GatewayClearance = {
    version: GATEWAY_CLEARANCE_VERSION,
    cleared_at_ms: now,
    expires_at_ms: now + GATEWAY_CLEARANCE_TTL_MS,
  };
  memoryClearance = value;
  try {
    window.localStorage.setItem(GATEWAY_CLEARANCE_KEY, JSON.stringify(value));
  } catch {
    memoryClearance = value;
  }
  return value;
}

export function clearClearance(): void {
  memoryClearance = null;
  try {
    window.localStorage.removeItem(GATEWAY_CLEARANCE_KEY);
  } catch {
    memoryClearance = null;
  }
}